"use client";

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import Table from "../../../../components/Table.jsx";
import Button from "../../../../components/Button.jsx";
import styles from "../css/ConsultationHistory.module.css";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5000";

export default function ConsultationHistoryServiceDetails() {
  const { id, serviceId } = useParams();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      setError("");
      try {
        const { getPatientServiceVisitHistory } = await import("../../../../api/clinic/consultationApi.js");
        const data = await getPatientServiceVisitHistory(id, serviceId);
        if (!mounted) return;
        setRows(Array.isArray(data) ? data : []);
      } catch (e) {
        if (!mounted) return;
        setError(e.message || 'Failed to load visit history');
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false };
  }, [id, serviceId]);

  const columns = [
    { header: "Date", accessor: "date" },
    { header: "Chronic Condition", accessor: "chronic" },
    { header: "Family History", accessor: "family" },
    { header: "Allergies", accessor: "allergies" },
    { header: "Obstetrics", accessor: "obstetrics" },
    { header: "Consult", accessor: "consult" },
  ];

  const data = rows.map((r) => ({ ...r }));

  return (
    <div className={styles.pageWrapper}>
      <Navbar />
      <main className={styles.container}>
        <h2 className={styles.pageTitle}>Consultation History</h2>

        <section className={styles.tableArea}>
          {error && (
            <div className={styles.inlineError}>{error}</div>
          )}
          {loading ? (
            <div className={styles.loadingMessage}>Loading...</div>
          ) : (
            <Table columns={columns} data={data} />
          )}
        </section>
      </main>
      <Footer />
    </div>
  );
}
